import { cx } from '@emotion/css';
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
export function withClassName(SelectComponent, className, extra) {
    return (props) => React.createElement(SelectComponent, Object.assign({}, props, { className: cx(props.className, className, extra && extra(props)) }));
}
export function withClassNameToInnerProps(SelectComponent, className) {
    return (props) => (React.createElement(SelectComponent, Object.assign({}, props, { innerProps: Object.assign(Object.assign({}, (props.innerProps || {})), { className: cx(props.innerProps && props.innerProps.className, props.className, className) }) })));
}
//# sourceMappingURL=WithClassName.js.map